import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useApp } from "@/context/AppContext";
import { CalendarRange, Calculator, Database } from "lucide-react";

// info: { title, value, period, how, sources:[], reason? , rows?:[{label,value}] }
export default function MetricDetailModal({ info, open, onClose }) {
  const { t } = useApp();
  if (!info) return null;
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent data-testid="metric-detail" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl">{info.title}</DialogTitle>
          <DialogDescription className="sr-only">{info.title}</DialogDescription>
        </DialogHeader>
        <div className="text-3xl font-data font-bold text-primary">{info.value}</div>

        <div className="flex items-center gap-2 text-sm bg-secondary rounded-md p-3">
          <CalendarRange className="w-4 h-4 text-primary shrink-0" />
          <span><span className="text-muted-foreground">{info.periodLabel}: </span><b>{info.period}</b></span>
        </div>

        {info.rows && info.rows.length > 0 && (
          <div className="space-y-1.5">
            {info.rows.map((r, i) => (
              <div key={i} className="flex justify-between text-sm border-b border-border/40 pb-1.5">
                <span className="text-muted-foreground">{r.label}</span>
                <span className="font-data font-medium">{r.value}</span>
              </div>
            ))}
          </div>
        )}

        {info.reason && (
          <div className="text-sm bg-accent/50 border border-primary/15 rounded-md p-3">
            <span className="text-muted-foreground">{t("why")} </span>{info.reason}
          </div>
        )}

        <div>
          <div className="flex items-center gap-2 mb-1"><Calculator className="w-4 h-4 text-primary" /><span className="text-sm font-semibold">{info.howLabel}</span></div>
          <p className="text-sm text-muted-foreground">{info.how}</p>
        </div>

        {info.sources && info.sources.length > 0 && (
          <div>
            <div className="flex items-center gap-2 mb-2"><Database className="w-4 h-4 text-primary" /><span className="text-sm font-semibold">{info.sourcesLabel}</span></div>
            <div className="flex flex-wrap gap-2">
              {info.sources.map((s, i) => <span key={i} className="text-xs bg-secondary rounded px-2 py-1">{s}</span>)}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
